import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "slider", "checkIcon"]

  connect() {
    console.log("NotificationFilter controller connected")
    this.isUnreadOnly = false
    this.updateToggleState()
  }

  toggle(event) {
    console.log("Toggle clicked, current state:", this.isUnreadOnly)
    this.isUnreadOnly = event.target.checked
    this.updateToggleState()
    this.filterNotifications()
  }

  updateToggleState() {
    console.log("Notification Filter Updating toggle state to:", this.isUnreadOnly)
    
    if (!this.hasToggleTarget || !this.hasSliderTarget || !this.hasCheckIconTarget) {
      console.error("Missing targets for notification filter")
      return
    }

    const toggle = this.toggleTarget
    const slider = this.sliderTarget
    const checkIcon = this.checkIconTarget

    if (this.isUnreadOnly) {
      // Toggle is ON - show unread only
      toggle.classList.remove("bg-gray-200", "dark:bg-gray-700")
      toggle.classList.add("bg-blue-600")
      slider.classList.remove("translate-x-0")
      slider.classList.add("translate-x-5")
      checkIcon.classList.remove("opacity-0")
      checkIcon.classList.add("opacity-100")
    } else {
      // Toggle is OFF - show all notifications
      toggle.classList.remove("bg-blue-600")
      toggle.classList.add("bg-gray-200", "dark:bg-gray-700")
      slider.classList.remove("translate-x-5")
      slider.classList.add("translate-x-0")
      checkIcon.classList.remove("opacity-100")
      checkIcon.classList.add("opacity-0")
    }
  }

  filterNotifications() {
    console.log("Filtering notifications, unread only:", this.isUnreadOnly)
    
    // Find the notification dropdown - it's a sibling element, not a parent
    const notificationCenter = this.element.closest('.notification-center')
    if (!notificationCenter) {
      console.error("Could not find notification center")
      return
    }
    
    const dropdown = notificationCenter.querySelector('.notification-dropdown')
    if (!dropdown) {
      console.error("Could not find notification dropdown")
      return
    }
    
    const notificationItems = dropdown.querySelectorAll('.notification-item')
    console.log("Found notification items:", notificationItems.length)
    
    notificationItems.forEach(item => {
      const isUnread = item.dataset.notificationUnread === 'true'
      console.log("Item unread status:", isUnread)
      
      if (this.isUnreadOnly) {
        // Show only unread notifications
        if (isUnread) {
          item.style.display = 'block'
        } else {
          item.style.display = 'none'
        }
      } else {
        // Show all notifications
        item.style.display = 'block'
      }
    })

    // Update group headers visibility
    this.updateGroupHeaders(dropdown)
  }

  updateGroupHeaders(dropdown) {
    const groupHeaders = dropdown.querySelectorAll('.sticky')
    
    groupHeaders.forEach(header => {
      // Find the corresponding notification list for this header
      const notificationsList = header.nextElementSibling
      if (notificationsList) {
        const visibleItems = notificationsList.querySelectorAll('.notification-item:not([style*="display: none"])')
        
        if (visibleItems.length === 0) {
          header.style.display = 'none'
        } else {
          header.style.display = 'block'
        }
      }
    })
  }
}
